// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"_2uDxNxAk"};